export var RealRewardStep;
(function (RealRewardStep) {
    RealRewardStep["EDIT"] = "edit";
    RealRewardStep["CONFIRM"] = "confirm";
    RealRewardStep["DONE"] = "done";
    RealRewardStep["PREVIEW"] = "preview";
})(RealRewardStep || (RealRewardStep = {}));
